import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { AvatarImageProps } from 'reka-ui';
    import { AvatarImage } from 'reka-ui';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AvatarImage',
  props: {
    src: {},
    referrerPolicy: {},
    crossOrigin: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AvatarImage), _mergeProps({ "data-slot": "avatar-image" }, props, { class: "h-full w-full rounded-[inherit] object-cover" }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16))
}
}

})